import { render, staticRenderFns } from "./VWarehouseImport.vue?vue&type=template&id=7a44f631"
import script from "./VWarehouseImport.vue?vue&type=script&lang=ts"
export * from "./VWarehouseImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports